import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { AuthApiService } from '../../../core/services/auth/auth-api.service';
import { FormBuilder, FormControl, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { EMAIL_REGEX } from '../constant/auth.constant';
import { NgClass } from '@angular/common';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [ReactiveFormsModule, NgClass],
  templateUrl: './forgot-password.component.html',
  styleUrl: '../user-authentification.component.scss',
})
export class ForgotPasswordComponent {
  @Input() initialEmail: string = '';
  @Output() close = new EventEmitter<void>();

  private _authService = inject(AuthApiService);
  private _fb: NonNullableFormBuilder = inject(FormBuilder).nonNullable;
  private _toast = inject(ToastrService);

  isSubmitted = false;
  loading = false;

  forgotPasswordForm = this._fb.group({
    email: ['', [Validators.required, Validators.pattern(EMAIL_REGEX)]],
  });

  get email(): FormControl<string> {
    return this.forgotPasswordForm.controls.email;
  }

  onSubmit(): void {
    this.isSubmitted = true;

    if (this.forgotPasswordForm.invalid) {
      return;
    }

    this.loading = true;

    this._authService.requestPasswordReset$(this.email.value).subscribe({
      next: () => {
        this._toast.success('Un e-mail de réinitialisation a été envoyé.', 'Succès');
        this.loading = false;
      },
      error: () => {
        this._toast.error('Une erreur est survenue lors de la demande. Veuillez réessayer.', 'Erreur');
        this.loading = false;
      },
    });
  }
}
